import { useState, useEffect, useRef } from "react";
import { graphql, useStaticQuery } from "gatsby";

export class Action {
}

/**
 * Normalize Shopify's `quantityAvailable` into a usable stock limit.
 *
 * For variants whose inventory is not tracked, or that keep selling when out
 * of stock, Shopify still returns `quantityAvailable` as 0 or negative while
 * `availableForSale` stays true. That number is not a real limit, so treat it
 * as unknown (null). Only a positive count on a sellable variant is meaningful;
 * a sold-out variant is signalled by `availableForSale === false` instead.
 */
export function normalizeQuantityAvailable(
  availableForSale: boolean | null | undefined,
  quantityAvailable: unknown,
): number | null {
  if (availableForSale === false) return null;
  if (typeof quantityAvailable !== 'number') return null;
  return quantityAvailable > 0 ? quantityAvailable : null;
}

export function numberWithCommas(x = '') {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    },[value]);
    return ref.current;
}



export const useIsMobile = () => {
    const [height, setHeight] = useState<number>(
        typeof  window !== "undefined" ? window.innerHeight: 1080
    );
    const [width, setWidth] = useState<number>(
        typeof  window !== "undefined" ? window.innerWidth : 1920
);

    function handleWindowSizeChange() {
        setWidth(
        typeof  window !== "undefined" ? window.innerWidth : 1920
        );
        setHeight(
            typeof  window !== "undefined" ? window.innerHeight : 1080
        );
    }
    useEffect(() => {
        if (typeof  window == "undefined") {
            return;
        }
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    return  { isMobile : width <= 768, screenWidth: width, screenHeight: height };
}

export const useSiteMetadata = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          image
          siteUrl
        }
      }
    }
  `)

  return data.site.siteMetadata
}
